import { DetailsListLayoutMode, Stack, Text } from '@fluentui/react'
import { constants } from 'modules/Advisory/shared/theme'
import React from 'react'
import { useDispatch } from 'react-redux'
import { ListsComponents } from '../../../../../features/Lists/core/containers/service'
import { IListsUiState } from '../../../../../features/Lists/core/contracts/IListsUIState'
import { ListsUiActions } from '../../../../../features/Lists/core/store/actions'
import { isNotNullOrUndefined } from '../../../../../shared/gaurds'

export const createDashboardList = (
  listComponents: ListsComponents,
  listUiActions: ListsUiActions,
  defaultState?: IListsUiState
) => {
  const { update } = listUiActions
  const DashboardList: React.FC = () => {
    const dispatch = useDispatch()
    return (
      <Stack tokens={{ childrenGap: 5 }}>
        <Stack horizontal={true} tokens={{ childrenGap: 10 }}>
          <listComponents.ListsSearch />
          <Stack.Item grow={1}>
            <listComponents.ListsFilterStatusList />
          </Stack.Item>

          <Text variant="medium" styles={{ root: { fontWeight: 'bold' } }}>
            <listComponents.ListsResultsCount /> Results
          </Text>
        </Stack>
        <Stack.Item>
          <Stack>
            <listComponents.ListsCommandBar
              additionalItems={[
                defaultState && {
                  key: 'reset',
                  text: 'Reset to Defaults',
                  iconProps: { iconName: 'Undo' },
                  onClick: () => {
                    dispatch(update(defaultState))
                  }
                }
              ].filter(isNotNullOrUndefined)}
            />
            <listComponents.ListsProgress />
            <listComponents.ListsInfiniteScrollDataTable
              layoutMode={DetailsListLayoutMode.justified}
              stickyHeaderOffset={constants.headerHeight}
            />
          </Stack>
        </Stack.Item>
      </Stack>
    )
  }
  return DashboardList
}
